import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Progress, Tooltip, Tabs, message, Spin, Modal } from "antd";
import { ReactComponent as Heart } from "../../assets/img/icons/heart.svg";
import { ReactComponent as SiloueteMale } from "../../assets/img/siluotteMale.svg";
import QuestionProfileCard from "../questionnaries/QuestionProfileCard";
import "./HealthProfile.module.css";
import Questionnaire from "../questionnaries/Questionnarie";
import {
  getQuestionaries,
  getQuestionaryByType,
} from "../../services/questionnaries";
import { getHealthProfile } from "../../services/patient";
import QuestionnarieList from "./Questionnaries/QuestionnarieList";
import { useParams } from "react-router-dom";
// import { PatientContext } from './PatientContext';
import { saveQuestionnary } from "../../services/patient";
import ModalQuestionnaire from "../questionnaries/ModalQuestionnarie";
import questionaries from "../../utils/enums/questionnaries";
import {
 arrowsRotate,
} from "../imagepath";

const HealthProfile = () => {
  //Create state for data survey
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [surveys, setSurveys] = useState([]);
  const [originalSurveys, setOriginalSurveys] = useState([]);
  const [isNewQuestionnaire, setIsNewQuestionnaire] = useState(false);
  const [questionaryKey, setQuestionaryKey] = useState(0);
  //Avg for silouete
  const [avg, setAvg] = useState(50);
  const [gender, setGender] = useState("F");

  const [framingham, setFramighat] = useState(0);
  const [modalQuestionnarieKey, setmodalQuestionnarieKey] = useState(0);

  //Modal Questionnarie Questions
  const [modalQuestions, setModalQuestions] = useState({
    title: "",
    questions: [],
    open: false,
  });

  let color = "#00b189";
  if (avg <= 50) {
    color = "#ffb600";
  }
  //Calculate height dynamically for silouete "progress bar"
  const heightStyle = { "--height": 100 - avg + "%" };

  //Age comparison
  const [currentAge, setCurrentAge] = useState(0);

  const onSaveQuestionnary = async (questionnaire) => {
    await saveQuestionnary({
      ...questionnaire,
      insuredMember: id,
    })
      .then(() => {
        message.success("Cuestionario completado!");
        setIsNewQuestionnaire(false);
        //Reset all questions
        setSurveys([]);
        setSurveys(originalSurveys);
        fetchData();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchData = async () => {
    //TODO: Change this for getQuestionnaries from patient pathologic or logic
    const response = await getQuestionaries(id);
    const data = response.map((survey, index) => {
      //Set questions property answerSelecteds = [];
      survey.questions.forEach((question) => {
        //set answerSelecteds = [] if answerSelecteds is undefined
        if (question.answerSelecteds === undefined) {
          question.answerSelecteds = [];
        }
      });
      return {
        label: survey.questionaireTitle,
        key: index + "questionnarie",
        children: (
          <Questionnaire
            questions={survey.questions}
            totalshowQuestion={5}
            onSave={onSaveQuestionnary}
          />
        ),
      };
    });

    setSurveys(data);
    setOriginalSurveys(data);

    //Get Health Profile data
    const healthProfile = await getHealthProfile(id);
    setAvg(healthProfile.avg);
    setGender(healthProfile.gender);
    setFramighat(healthProfile.ecvRiskFraming);
    setCurrentAge(healthProfile.age);
    setIsLoading(false);
  };

  const addQuestionnaire = () => {
    setIsNewQuestionnaire(!isNewQuestionnaire);
    if (isNewQuestionnaire){
      const newIndex = questionaryKey+1;
      setQuestionaryKey(newIndex);
    }
  };

  const closeFraminghanQuestionnaire = () => {
    //Restart all questions
    setModalQuestions({
      title: "Framigham",
      questions: [],
      open: false,
    });
  };

  const getFraminghanQuestionnaire = async () => {
    const response = await getQuestionaryByType(questionaries.Framinghan);
    //Reset all questions answerSelecteds = [];
    setmodalQuestionnarieKey(modalQuestionnarieKey + 1);

    response.map((survey) => {
      //Set questions property answerSelecteds = [];
      survey.questions.forEach((item) => {
        //set answerSelecteds = [] if answerSelecteds is undefined
        if (item.answerSelecteds === undefined) {
          item.answerSelecteds = [];
        }

        //Set Age when the question is about age
        if (item.question.value == "Edad:") {
          item.answerSelecteds = [{ value: currentAge }];
          item.question.readOnly = true;
          //Set answer mock wait for configuration
          item.answers = [
            {
              id: "ReadOnly",
              value: currentAge,
            },
          ];
        }
      });

      setModalQuestions({
        title: "Framigham",
        questions: survey.questions,
        open: true,
      });
    });
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (surveys.length == 0) {
        fetchData();
      }
    }
    return () => {
      mounted = false;
    };
  }, [false]);

  return isLoading ? (
    <div className="text-center">
      <Spin size="large" />
    </div>
  ) : (
    <div className="container">
      <div>
        <ul className="nav nav-tabs nav-tabs-solid">
          <li className="nav-item active">
            <Link
              to="#rcv-health"
              data-bs-toggle="tab"
              className="nav-link active"
            >
              RCV
            </Link>
          </li>
          <li className="nav-item">
            <Link to="#survey-health" data-bs-toggle="tab" className="nav-link">
              Cuestionarios
            </Link>
          </li>
        </ul>
      </div>
      <div className="tab-content">
        <div className="tab-pane show active" id="rcv-health">
          <div className="row">
            <div className="col-md-3">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "50px",
                  height: "100%",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <b>Framingham </b>
                  <button
                    className="btn btn-sm btn-primary mt-2"
                    onClick={getFraminghanQuestionnaire}
                  >
                    <img 
                      width={12}
                      height={12}
                      className="far"
                      src={arrowsRotate} alt=""/>
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Heart
                    style={{
                      fill: color,
                      ...heightStyle,
                    }}
                  />

                  <span
                    style={{
                      float: "left",
                      fontSize: "1.9rem",
                      position: "absolute",
                      marginBottom: "50px",
                      fontWeight: "700",
                      color: "white",
                    }}
                  >
                    {avg}%
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12  ">
              <div className="row mt-4">
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Cómo está la presión arterial?",
                        currentValue: "120/80",
                        measure: "Pressure",
                        measureText: "mmHg",
                        minGoal: "120/80",
                        maxGoal: "120/80",
                      },
                    ]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Cómo están los hábitos alimenticios?",
                        currentValue: "Bien",
                        goal: "Bien",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Cómo está el peso?",
                        currentValue: "70",
                        measure: "Goal",
                        measureText: "kg",
                        goal: "60",
                      },
                    ]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Realiza + de 120 min de actividad física?",
                        currentValue: "Sí",
                        goal: "Sí",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Cómo está el colesterol LDL?",
                        measure: "RangeGoal",
                        currentValue: "201",
                        minGoal: "1",
                        maxGoal: "200",
                      },
                      {
                        question: "¿Cómo está el colesterol HDL?",
                        currentValue: "45",
                        measure: "RangeGoal",
                        minGoal: "35",
                        maxGoal: "60",
                      },
                    ]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Consume tabaco o cigarrillo?",
                        currentValue: "No",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Cómo está mi azúcar en sangre?",
                        currentValue: "90 mg/dL",
                      },
                    ]}
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <QuestionProfileCard
                    questions={[
                      {
                        question: "¿Se autopercibe saludable?",
                        currentValue: "Sí",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane" id="survey-health">
          <div className="row">
            <div className="col-12 col-md-12 col-xl-12 text-end mr-2 mb-4">
              <button className="btn btn-primary" onClick={addQuestionnaire}>
                {isNewQuestionnaire ? "Regresar" : "Agregar Cuestionario"}
              </button>
            </div>
          </div>
          {isNewQuestionnaire == false ? (
            <QuestionnarieList insuredMember={id} />
          ) : (
            <Tabs items={surveys} key={questionaryKey} />
          )}
        </div>
      </div>
      <ModalQuestionnaire
        title={modalQuestions.title}
        questions={modalQuestions.questions}
        totalshowQuestion={15}
        open={modalQuestions.open}
        close={() => closeFraminghanQuestionnaire()}
        onSave={onSaveQuestionnary}
        idx={modalQuestionnarieKey}
      />
    </div>
  );
};

export default HealthProfile;
